export default {
  de: {
    email: "E-Mail",
    type: "Art",
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefon',
    personalNumber: 'Personalnummer',
    oldPassword: 'Altes Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort wiederholen',
    notification: {
      edit: {
        type: 'success',
        message: 'Benutzer erolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      },
      delete: {
        type: 'success',
        message: 'Benutzer erolgreich gelöscht',
        title: 'Erfolgreich gelöscht'
      },
      changePassword: {
        type: 'success',
        message: 'Passwort erfolgreich geändert',
        title: 'Passwort geändert'
      }
    }
  }
}
